module.exports = __webpack_public_path__ + "media/homepage_video_medium_resolution.78e31d80.mp4";